import gql from "graphql-tag";

export const PRODUCT = gql`query ($id: ID!) {
    product(id: $id) {
        id
        name
        productCategoryId
        price
        description
        photoUrl
        choices {
            title
            type
            required
            note
            minOptions
            maxOptions
            options {
                description
                details
                price
            }
        }
        order
        isDeleted
    }
}`;

export const DELETE_PRODUCT = gql`mutation ($id: ID!) {
    deleteProduct(id: $id) {
        id
    }
}`;

export const REORDER_PRODUCTS = gql`mutation ($productCategoryId: ID! $inputs: [ReorderInput!]!) {
    reorderProduts(
        productCategoryId: $productCategoryId
        inputs: $inputs
    ) {
        id
        order
    }
}`;

export const CREATE_PRODUCT = gql`mutation ($input: ProductInput!) {
    createProduct(
        input: $input
    ) {
        id
        name
        productCategoryId
        price
        description
        photoUrl
        photoThumbUrl
        choices {
            title
            type
            required
            note
            minOptions
            maxOptions
            options {
                description
                details
                price
            }
        }
        order
    }
}`;

export const UPDATE_PRODUCT = gql`mutation ($id: ID! $input: ProductInput!) {
    updateProduct(
        id: $id
        input: $input
    ) {
        id
        name
        productCategoryId
        price
        description
        photoUrl
        photoThumbUrl
        choices {
            title
            type
            required
            note
            minOptions
            maxOptions
            options {
                description
                details
                price
            }
        }
        order
    }
}`;